import React from 'react';

import { components, ControlProps, GroupBase, MenuProps, OptionProps, PlaceholderProps } from 'react-select';

import { CheckIcon } from 'components/icons/v2';

export interface ICreatableNewOption {
  label: string;
  value: string;
  __isNew__: boolean;
}

export const ControlComponent = <T,>(props: ControlProps<T, boolean, GroupBase<T>>): JSX.Element => {
  return (
    <components.Control
      {...props}
      className={`${props.selectProps.error ? '!border-error-500' : '!border-gray-200'} !shadow-none py-[2px] flex flex-1 border items-center gap-md !rounded-radius-xl  focus:outline-none text-medium text-gray-900 disabled:bg-gray-50 disabled:text-gray-200 disabled:cursor-not-allowed !bg-gray-25`}

    >
      {!!props.selectProps.icon && props.selectProps.icon}
      {props.children}
    </components.Control>
  );
};

export const OptionComponent = <T,>(props: OptionProps<T, boolean, GroupBase<T>>): JSX.Element => {
  return (
    <components.Option
      {...props}
      className={`p-[10px] text-small !text-gray-950 hover:!bg-gray-50 !bg-white !flex justify-between flex-1 ${props.isSelected && '!bg-gray-50'}`}
    >
      <span>{props.children}</span>
      {props.isSelected && (
        <CheckIcon className="text-brand-500" />
      )}
    </components.Option>
  );
};

export const OptionWithoutSelectedComponent = <T,>(props: OptionProps<T, boolean, GroupBase<T>>): JSX.Element => {
  return (
    <components.Option
      {...props}
      className={`p-[10px] text-small !text-gray-950 hover:!bg-gray-50 !bg-white !flex justify-between flex-1`}
    >
      <span>{props.children}</span>
    </components.Option>
  );
};

export const MenuComponent = <T,>(props: MenuProps<T, boolean, GroupBase<T>>): JSX.Element => {
  return (
    <components.Menu
      {...props}
      className="!border-2 border-brand-600 !shadow-lg !rounded-radius-xl overflow-hidden !bg-gray-25"
    >
      {props.children}
    </components.Menu>
  );
};

export const PlaceholderComponent = <T,>(props: PlaceholderProps<T, boolean, GroupBase<T>>): JSX.Element => {
  return (
    <components.Placeholder
      {...props}
      className="!text-gray-300 !text-medium !bg-gray-25"
    >
      {props.children}
    </components.Placeholder>
  );
};
